/**
 * Application Constants
 * 
 * Centralized configuration values and constants.
 */

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_ENDPOINTS = {
  ELIGIBILITY: '/api/eligibility',
  CONTACT: '/api/contact',
  HEALTH: '/api/health',
  SYSTEM_CHECK: '/api/system-check',
};

// Company Information
export const COMPANY = {
  NAME: 'Canadian Document Services Inc.',
  PHONE: '(866) 554-3535',
  PHONE_HREF: 'tel:+18665543535',
  ADDRESS: {
    STREET: '5000 Yonge St. Suite 1901',
    CITY: 'North York',
    PROVINCE: 'ON',
    POSTAL: 'M2N 7E9',
    COUNTRY: 'Canada',
  },
  HOURS: {
    WEEKDAY: '9:00 AM - 5:00 PM EST',
    WEEKEND: 'Closed',
  },
};

// Form Configuration
export const FORM_CONFIG = {
  // Rate limiting messages
  RATE_LIMIT_MESSAGE: 'Too many requests. Please try again later.',
  GENERIC_ERROR_MESSAGE: 'An error occurred. Please try again.',
  
  // Consent text - plain language disclosure
  CONSENT_DISCLOSURE: `I consent to being contacted by Canadian Document Services Inc. regarding my eligibility review and related service communication. I understand that Canadian Document Services Inc. is not a government agency and provides administrative assistance only.`,
  
  // Data collection notice
  DATA_NOTICE: 'We collect only the information needed to assess your eligibility and contact you. We do not collect SIN, DOB, or criminal record details during this assessment.',
};

// Services offered
export const SERVICES = [
  { 
    value: 'record_suspension', 
    label: 'Record Suspension', 
    description: 'Clear your criminal record under the Criminal Records Act' 
  },
  { 
    value: 'us_entry_waiver', 
    label: 'U.S. Entry Waiver', 
    description: 'Gain legal entry to the United States despite inadmissibility' 
  },
  { 
    value: 'international_filings', 
    label: 'International Filings', 
    description: 'Document authentication for international use' 
  },
];

// Assessment reasons
export const ASSESSMENT_REASONS = [
  { value: 'travel', label: 'Travel Related', description: 'Need to travel internationally' },
  { value: 'employment', label: 'Employment Related', description: 'Required for work or job application' },
  { value: 'personal_clarity', label: 'Personal Clarity', description: 'Want to understand your options' },
];

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  COMPANY,
  FORM_CONFIG,
  SERVICES,
  ASSESSMENT_REASONS,
};
